function observacaoPreVenda(valor) {
  return String(valor ?? "")
    .split(/\r?\n/)
    .filter(linha => !/^\s*vendedor\s*:/i.test(linha))
    .join("\n")
    .trim();
}

module.exports = { observacaoPreVenda };
